import React from 'react';

const TriggersSkeleton: React.FC = () => {
  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-40 animate-pulse"></div>
        <div className="h-7 bg-gray-200 dark:bg-gray-700 rounded w-28 animate-pulse"></div>
      </div>
      <div className="space-y-3 max-h-[350px] overflow-y-auto pr-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="bg-white dark:bg-secondary-dark rounded-lg border border-gray-200 dark:border-gray-700 p-4 animate-pulse">
            <div className="flex items-center gap-4 w-full">
              <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-lg flex-shrink-0"></div>
              <div className="flex-1 min-w-0 flex flex-col justify-center gap-2">
                <div className="flex items-center gap-3">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
                  <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-full w-16 flex-shrink-0"></div>
                  <div className="flex-1"></div>
                </div>
                <div className="flex items-center gap-4 w-full">
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-48"></div>
                  <div className="flex flex-wrap gap-1.5 items-center flex-1">
                    <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-full w-20"></div>
                    <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-full w-16"></div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center gap-3 flex-shrink-0">
                <div className="h-6 w-11 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
                <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TriggersSkeleton;